import { useContext } from 'react'
import { RosterCandidatesColumnsContext } from 'client/candidate-table-temp/contexts/RosterCandidatesColumnsContext'

/**
 * Provides column definitions and visibility controls for roster candidates tables
 */
export const useRosterCandidatesColumns = () => {
    const rosterCandidatesColumnsContext = useContext(
        RosterCandidatesColumnsContext
    )

    if (!rosterCandidatesColumnsContext) {
        throw new Error(
            'useRosterCandidatesColumns must be used within <RosterCandidateColumnsProvider>'
        )
    }

    return rosterCandidatesColumnsContext
}
